import { render, staticRenderFns } from "./EnqueteAnswer.vue?vue&type=template&id=640ec5e9&scoped=true"
import script from "./EnqueteAnswer.vue?vue&type=script&lang=js"
export * from "./EnqueteAnswer.vue?vue&type=script&lang=js"
import style0 from "./EnqueteAnswer.vue?vue&type=style&index=0&id=640ec5e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ec5e9",
  null
  
)

export default component.exports